// extracted by mini-css-extract-plugin
export var active = "_tk-1";
export var circle = "_tk-0";
export var completed = "_tk-2";
export var connector = "_tk-4";
export var connectorCompleted = "_tk-7";
export var connectorSpacer = "_tk-5";
export var iconStrokeOverride = "_tk-8";
export var labelContainer = "_tk-6";
export var pending = "_tk-3";